import { ChatRoom } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore, subscribeOnGroupChatRoomUpdated } from '@dinosband/bv-main-client'
import { BvSubscriber } from './manager/subscriber'

export class GroupChatRoomSubscriber extends BvSubscriber<ChatRoom> {

  mainStore: MainStore
  limit?: { chatRoomIds: number[] }

  constructor (context: { mainStore: MainStore, limit?: { chatRoomIds: number[]}}, callback: (value: ChatRoom | ChatRoom[]) => void) {
    super(callback)
    this.mainStore = context.mainStore
    this.limit = context.limit
  }

  protected async query () { return undefined }

  protected async subscribe () {
    const userId = this.mainStore.userId
    if (!userId || userId <= 0) {
      return
    }
    const client = await this.mainStore.apollo.getClient()
    const subUpdated = subscribeOnGroupChatRoomUpdated(client, userId, this.callback)
    return subUpdated
  }

}
